module.exports = __webpack_public_path__ + "static/media/crypto.be73c562.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team_logo/crypto.png
// module id = 1405
// module chunks = 0